var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1618_2797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.44927 2.90108L10.2775 2.07288L11.7415 3.53692L14.1718 1.10654L15 1.93475L11.7415 5.19322L9.44927 2.90108ZM14.103 4.48815C14.6835 5.56584 14.9916 6.77686 14.9916 8.03536C14.9916 10.0376 14.212 11.9199 12.7962 13.3358C11.3805 14.7516 9.49802 15.5211 7.49588 15.5211C5.49362 15.5211 3.6113 14.7516 2.19543 13.3358C0.779686 11.9199 0 10.0376 0 8.03536C0 6.03322 0.779686 4.15078 2.19543 2.73503C3.6113 1.31928 5.49362 0.529297 7.49588 0.529297C8.28861 0.529297 9.06246 0.662277 9.79614 0.897797L8.83919 1.85487C8.40603 1.7608 7.95673 1.71078 7.49588 1.71078C4.00841 1.71078 1.17119 4.548 1.17119 8.03536C1.17119 9.63078 1.76537 11.09 2.74349 12.2039C3.08384 10.681 4.13921 9.42525 5.53768 8.80853C4.9538 8.27615 4.58679 7.50974 4.58679 6.65921C4.58679 5.05521 5.89176 3.75012 7.49588 3.75012C9.09988 3.75012 10.4049 5.05509 10.4049 6.65921C10.4049 7.50974 10.038 8.27615 9.45408 8.80853C10.8524 9.42525 11.9079 10.681 12.2482 12.2039C13.2264 11.0899 13.8205 9.63078 13.8205 8.03536C13.8205 7.08115 13.6076 6.1757 13.2275 5.36362L14.103 4.48815ZM7.49588 8.397C8.45409 8.397 9.23367 7.61742 9.23367 6.65921C9.23367 5.70088 8.45409 4.92131 7.49588 4.92131C6.53755 4.92131 5.75798 5.70088 5.75798 6.65921C5.75798 7.61742 6.53755 8.397 7.49588 8.397ZM7.49588 14.3601C8.87489 14.3601 10.1521 13.916 11.1926 13.1639C11.1381 11.172 9.50077 9.56818 7.49588 9.56818C5.49099 9.56818 3.85357 11.172 3.79921 13.1639C4.83971 13.916 6.11675 14.3601 7.49588 14.3601Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1618_2797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.8ac9ff9b19f081dda7dfe7430121b9fb.svg";
export { ForwardRef as ReactComponent };